module.exports = __webpack_public_path__ + "img/toast-warning.32ce5c59.svg";